// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.md-country-picker-item {
  position: relative;
  line-height: 20px;
  padding: 10px 0 10px 40px;
}

.md-country-picker-flag {
  position: absolute;
  left: 0;
  height: 20px;
}

.mbsc-scroller-wheel-item-2d .md-country-picker-item {
  transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/app/components/selector-idioma/selector-idioma.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,iBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,OAAA;EACA,YAAA;AACJ;;AAEA;EACI,qBAAA;AACJ","sourcesContent":[".md-country-picker-item {\r\n    position: relative;\r\n    line-height: 20px;\r\n    padding: 10px 0 10px 40px;\r\n}\r\n\r\n.md-country-picker-flag {\r\n    position: absolute;\r\n    left: 0;\r\n    height: 20px;\r\n}\r\n\r\n.mbsc-scroller-wheel-item-2d .md-country-picker-item {\r\n    transform: scale(1.1);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
